import { LoginPage } from "@/features/auth/LoginPage";
import { HomePage } from "@/features/home/HomePage";
import { InventoryAdminPage } from "@/features/inventory/InventoryAdminPage";
import { InventoryEditPage } from "@/features/inventory/InventoryEditPage";
import { RoomBuilderPage } from "@/features/room-builder/RoomBuilderPage";
import { StagingDetailPage } from "@/features/staging-view/StagingDetailPage";
import { StagingPrintPage } from "@/features/staging-view/StagingPrintPage";
import { StagingEditPage } from "@/features/stagings/StagingEditPage";
import { StagingsAdminPage } from "@/features/stagings/StagingsAdminPage";
import { TemplatesPage } from "@/features/templates/TemplatesPage";
import { UsersPage } from "@/features/users/UsersPage";
import { Route, Routes } from "react-router-dom";
import { AppShell } from "./layout/AppShell";
import { RequireAdmin } from "./RequireAdmin";
import { RequireAuth } from "./RequireAuth";

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          <Route path="/" element={<HomePage />} />
          <Route element={<RequireAdmin />}>
            <Route path="/administration/users" element={<UsersPage />} />
          </Route>
          <Route path="/administration/stagings" element={<StagingsAdminPage />} />
          <Route path="/administration/stagings/:id" element={<StagingEditPage />} />
          <Route path="/administration/inventory" element={<InventoryAdminPage />} />
          <Route path="/administration/inventory/:id" element={<InventoryEditPage />} />
          <Route path="/administration/templates" element={<TemplatesPage />} />
          <Route path="/staging/:id" element={<StagingDetailPage />} />
          <Route path="/staging/:id/print" element={<StagingPrintPage />} />
          <Route path="/staging/:id/room-builder" element={<RoomBuilderPage />} />
          <Route path="/staging/:id/room-builder/:roomId" element={<RoomBuilderPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
